<template>
<div style="height:100%;">
    <v-card class="fill-height" height="100%">
    <v-toolbar
      flat
      height="auto"
      class="elevation-5"
    >
    <v-row>
        <v-col sm="12" md="6" lg="6" xl="6" cols="12" xs="12">
            <v-toolbar-title style="white-space: pre-wrap; word-wrap: break-word;">
                <h4>Транспортные средства</h4>
                <h6 class="text--disabled">Транспортные средства внешних систем мониторинга</h6>
            </v-toolbar-title>
        </v-col>
        <v-spacer/>
        <v-spacer/>
        <v-col class="d-flex flex-row-reverse" sm="12" md="3" lg="3" xl="3" cols="12">
          <v-btn v-on:click="LoadData" x-large color="primary" v-bind:disabled="loading">
            <v-icon left class="pr-5 ml-2" x-large>mdi-refresh</v-icon>
            Обновить
          </v-btn>
        </v-col>

    </v-row>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Поиск.."
        single-line
        hide-details
        v-bind:disabled="loading"
      ></v-text-field>
    </v-card-title>
    <v-card-text style="padding:0px; width:100%;">
        <v-skeleton-loader
            v-if="loading"
            style="height:100%"
            type="table"
            tile
          >
          </v-skeleton-loader>
        <div v-else class="fill-height table-container">
          <v-data-table
             ref="expandableTable"
            group-by="schemaName"
            :footer-props="{
              'items-per-page-options': [5, 10, 15]
            }"
            :search="search"
            :headers="headers"
            :items="devices"
            style="margin-bottom:50px;"

          >
          <template v-slot:group.header="{items, isOpen, toggle}">
            <th colspan="10">
              <v-icon @click="toggle"
                >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
              </v-icon>
              Схема: {{ items[0].schemaName }}
            </th>
          </template>
          <template v-slot:item.actions="{ item }">
            <EditDeviceForm
            v-bind:item="item"
             v-on:onValidate="UpdateData" />
          </template>
          <template v-slot:item.lastUpdateDateTime="{ item }">
            {{calculateLastUpdateDate(item.lastUpdateDateTime)}}
          </template>
          </v-data-table>
        </div>
    </v-card-text>
    </v-card>
</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import EditDeviceForm from '../../components/EditDeviceForm'
export default {
  mounted () {
    document.title = 'Транспортные средства - ATK Web'
    this.getDevices()
    this.getCards()
  },
  computed: {
    ...mapState('device', {
      devices: state => state.devices,
      loading: state => state.loading
    })
  },
  components: {
    EditDeviceForm
  },
  methods: {
    ...mapActions({
      getDevices: 'device/getDevices',
      updateDevice: 'device/updateDevice',
      getCards: 'device/getCards'
    }),
    calculateLastUpdateDate (date) {
      const currentDate = new Date(date)
      const GMT_DIFF = -new Date().getTimezoneOffset() / 60
      currentDate.setHours(currentDate.getHours() + GMT_DIFF)
      return currentDate.toLocaleDateString('ru-RU', { month: 'short', day: 'numeric', year: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    LoadData () {
      this.getDevices()
      this.LoadCards()
    },
    UpdateData (item) {
      this.updateDevice(item)
      this.$refs.expandableTable.collapseAll()
    }
  },
  data () {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 4,
        totalItems: 1,
        rowsPerPageItems: [1, 2, 4, 8, 16]
      },
      search: '',
      headers: [
        {
          text: 'Схема',
          align: 'start',
          sortable: false,
          value: 'schemaName',
          group: true
        },
        { text: 'Последнее обновление', value: 'lastUpdateDateTime', groupable: false },
        { text: 'Наименование', value: 'deviceName', groupable: false },
        { text: 'Гос.номер', value: 'vehicleRegNumber', groupable: false },
        { text: '№ Карты ППР', value: 'petrolCard.cardNumber', groupable: false },
        { text: '№ Карты Опти24', value: 'optiCard.cardNumber', groupable: false },
        { text: '№ Карты NESTE OIL', value: 'nesteCard.cardNumber', groupable: false },
        { text: '№ Карты Роснефть', value: 'rnCard.cardNumber', groupable: false },
        { text: '№ Карты Shell', value: 'shellCard.cardNumber', groupable: false },
        { text: 'Действия', value: 'actions', sortable: false }
      ],
      transition: 'expand-transition',
      hide: true,
      window: {
        width: 0,
        height: 0
      }
    }
  }
}
</script>
